module.exports = __webpack_public_path__ + "static/media/Finding my career options.df3b2f80.pdf";